import { FileType } from '@office-start/document-types';
export function shouldAddLoginHintToUrl(document) {
    // Only add login_hint to ODSP and some OWA URLs for now. Once all apps support login_hint add to them too.
    // login_hint is added to make sure the right identity is used when account switching is enabled.
    // For Edgeworth files, we check the 'source' property, but for MRU++ files we use the file type
    // Don't add login_hint to OWA calendar links as OWA does not handle calendar URLs correctly.
    // TODO: enable calendar links once OWA bug is fixed.
    return (!document.isLocalFile &&
        !document.isOnPremOrVanity &&
        (document.isOneDriveForBusinessFile ||
            document.isSharePointFile ||
            document.isEmailAttachment ||
            (document.fileType !== FileType.Sway &&
                document.fileType !== FileType.Forms &&
                document.fileType !== FileType.PowerBI &&
                document.fileType !== FileType.MeetingObject)));
}
//# sourceMappingURL=shouldAddLoginHintToUrl.js.map